import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
import './HHGestionT2.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ModalCerrarServicio from '../components/ModalCerrarServicio';
import ModalConcluirServicio from '../components/ModalConcluirServicio';
import jsPDF from 'jspdf';
import logo from '../assets/gorion.png'; // Ruta a tu logo
import { current } from '@reduxjs/toolkit';
import API_BASE_URL from '../config';
import SignatureCanvas from 'react-signature-canvas';
import HoldButton from '../components/HoldButton';


const moment = require('moment-timezone');

const DailyOperatorsInfo = () => {
  const [operators, setOperators] = useState([]);
  const [filteredOperators, setFilteredOperators] = useState([]);
  const [searchSiglas, setSearchSiglas] = useState(''); // Para el campo de búsqueda
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedOperator, setSelectedOperator] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showCerrarServicioModal, setShowCerrarServicioModal] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [isModalTransferOpen, setIsModalTransferOpen] = useState(false);
  const [siglas, setSiglas] = useState('');
  const [noColaboradorDestino, setNoColaboradorDestino] = useState('');
  const [loadingTransfer, setLoadingTransfer] = useState(false);
  const [servicioTransferencia, setServicioTransferencia] = useState(null);
  const [operadoresDisponibles, setOperadoresDisponibles] = useState([]);
  const [isModalSeleccionOpen, setIsModalSeleccionOpen] = useState(false);
  const [isConcluirModalOpen, setIsConcluirModalOpen] = useState(false);
  const [modalCorral, setModalCorral] = useState({ abierto: false, servicio: null });
  const [mostrarModalEncuesta, setMostrarModalEncuesta] = useState(false);
const [feedback, setFeedback] = useState('');
const [comentarios, setComentarios] = useState('');
const firmaPasajeroRef = useRef(null);
const firmaAgenteRef = useRef(null);
const ESTADOS_SERVICIO = {
  LLEGADAS: {
    NACIONAL: ["ASIGNADO", "INICIADO", "EQUIPAJE", "STDBY", "CONCLUIDO", "NOSHOW"],
    INTERNACIONAL: ["ASIGNADO", "INICIADO", "STDBY", "MIGRACION", "EQUIPAJE", "ADUANA", "CONCLUIDO", "NOSHOW"],
  },
  SALIDAS: {
    NACIONAL: ["ASIGNADO", "INICIADO", "EQUIPAJE", "STDBY", "CONCLUIDO", "NOSHOW"],
    INTERNACIONAL: ["ASIGNADO", "INICIADO", "EQUIPAJE", "STDBY", "CONCLUIDO", "NOSHOW"],
  },
};

const [modalQR, setModalQR] = useState({ abierto: false, servicio: null });
const [codigoQR, setCodigoQR] = useState('');
const [qrValidado, setQrValidado] = useState(false);
const [erroresQR, setErroresQR] = useState([]);





  const token = useSelector((state) => state.auth.token);
  const decoded = token ? jwtDecode(token) : null;
const estacionUsuario = decoded?.estacion?.trim().toUpperCase();



  useEffect(() => {
    const fetchOperators = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}api/servicios/daily-info`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        // Filtramos por estación directamente aquí
        console.log("Datos recibidos:", response.data); // <-- Añade esto

const dataFiltrada = response.data.filter(
  (op) => op.estacion?.trim().toUpperCase() === estacionUsuario
);


        setOperators(dataFiltrada);
        setFilteredOperators(dataFiltrada)
      } catch (error) {
        console.error('Error al obtener la información de operadores:', error);
      }
    };

    

    if (token) {
      fetchOperators();
    }
  }, [token, estacionUsuario]);

  const handleSearchSiglas = (event) => {
    const searchValue = event.target.value;
    setSearchSiglas(searchValue);
    
    if (searchValue === '') {
      // Si no hay texto en el campo de búsqueda, mostramos todos los operadores
      setFilteredOperators(operators);
    } else {
      // Filtrar los operadores por siglas
      const filtered = operators.filter((operator) =>
        operator.siglas.toLowerCase().includes(searchValue.toLowerCase())
      );
      setFilteredOperators(filtered);
    }
  };

  const abrirModalSeleccionOperador = async () => {
  try {
    setLoadingTransfer(true);
    const response = await axios.get(
      `${API_BASE_URL}api/bitacora/en-turno-detalles`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    // 🔥 Aquí filtramos solo los operadores de la estación actual
    const operadoresFiltrados = response.data.filter(
      (op) => op.estacion?.trim().toUpperCase() === estacionUsuario
    );

    setOperadoresDisponibles(operadoresFiltrados);
    setLoadingTransfer(false);
  } catch (error) {
    console.error('Error al cargar operadores:', error);
    toast.error('Hubo un error al cargar los operadores disponibles.', {
      position: 'top-right',
      autoClose: 3000,
    });
    setLoadingTransfer(false);
  }
};
const abrirModalCorral = (servicio) => {
  setModalCorral({ abierto: true, servicio });
};


  const handleCardClick = async (operator) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}api/servicios/colaborador/${operator.noColaborador}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    // Agregamos el campo `expanded` a cada servicio
    const serviciosConEstado = response.data.map((servicio) => ({
      ...servicio,
      expanded: false, // o false si quieres que inicien cerrados
    }));

    setSelectedServices(serviciosConEstado);
    setSelectedOperator(operator);
    setShowModal(true);
  } catch (error) {
    console.error('Error al obtener servicios:', error);
  }
};


  const refreshServices = async (operator) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}api/servicios/colaborador/${operator.noColaborador}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    const serviciosConEstado = response.data.map((servicio) => ({
      ...servicio,
      expanded: false, // o false
    }));

    setSelectedServices(serviciosConEstado);
  } catch (error) {
    console.error('Error al actualizar los servicios:', error);
  }
};


  const transferirServicio = async () => {
    if (!noColaboradorDestino) {
      toast.warning('Primero debe seleccionar un operador válido.', {
        position: 'top-right',
        autoClose: 3000,
      });
      return;
    }
    try {
      setLoadingTransfer(true);
      await axios.put(
        `${API_BASE_URL}api/servicios/${servicioTransferencia._id}`,
        { noColaborador: noColaboradorDestino },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      toast.success('Servicio transferido exitosamente.', {
        position: 'top-right',
        autoClose: 3000,
      });
      setTimeout(() => {
        window.location.reload();
      }, 3000);
      setIsModalTransferOpen(false);
    } catch (error) {
      console.error('Error al transferir servicio:', error);
      toast.error('Hubo un error al transferir el servicio.', {
        position: 'top-right',
        autoClose: 3000,
      });
    } finally {
      setLoadingTransfer(false);
    }
  };

  const abrirModalConcluir = (servicio) => {
    setSelectedService(servicio);
    setIsConcluirModalOpen(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedServices([]);
    setSelectedOperator(null);
  };

  const cerrarModalTransferencia = () => {
    setIsModalTransferOpen(false);
    setServicioTransferencia(null);
    setSiglas('');
    setNoColaboradorDestino('');
  };

  const abrirModalTransferencia = () => {
    setIsModalTransferOpen(true);
    setSiglas('');
    setNoColaboradorDestino('');
  };

  // Para el modal de selección de operador (transferencia)
  const filteredOperadores = operadoresDisponibles.filter((operador) => {
    const searchLower = operador.nombreCompleto.toLowerCase();
    return searchLower.includes(siglas.toLowerCase());
  });

  const handleReprintTicket = async (service) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}api/operadores/${service.noColaborador}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const operadorAsign = response.data;
    
    // Crear el documento PDF
    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: [58, 120], // 58mm de ancho, altura variable
    });
  
    // Agregar logo
    doc.addImage(logo, 'PNG', 4, 4, 50, 20); // X, Y, Ancho, Alto
  
    // Fecha del servicio
    doc.setFontSize(12);
    doc.text(`Fecha: ${moment().tz('America/Mexico/City').format('YYYY-MM-DD HH:mm:ss')}`, 4, 30);
  
    // Agregar detalles del ticket
    doc.setFontSize(10);
    doc.text(`Aerolinea: ${service.aerolinea}`, 4, 35);
    doc.text(`No. Vuelo: ${service.noVuelo}`, 4, 40);
    const nombreOperador = `Operador: ${operadorAsign.nombre} ${operadorAsign.apellidos} - ${service.noColaborador}`;
    const splitOperatorText = doc.splitTextToSize(nombreOperador, 50)
    doc.text(splitOperatorText, 4, 45)
    doc.text(`No. TIA: ${operadorAsign.tia || '2502432'}`, 4, 55);
    doc.text(`Silla: ${service.sillaRuedas}`, 4, 60);
  
    // Nombre del pasajero y otros detalles
    const passengerText = `Pasajero: ${service.nombrePax}`;
    const maxWidth = 50;
    const splitPassengerText = doc.splitTextToSize(passengerText, maxWidth);
    let currentY = 70;
    doc.text(splitPassengerText, 4, currentY);
  
    // Mensaje final
    doc.setFontSize(12);
    doc.text('------------------------------------------', 4, currentY + 10);
    doc.text('La calidad en el servicio,', 4, currentY + 15);
    doc.text('     nos caracteriza', 4,currentY +20 )
    doc.text('Servicio gratuito', 4, currentY + 25);
    doc.setFontSize(9);
    doc.text('Quejas: 55-2729-1171', 4, currentY + 30);
    doc.setFontSize(12);
    doc.text('-----------------------------------------', 4, currentY + 35);
  
    // Abrir el PDF en una nueva pestaña
    const pdfURL = doc.output('bloburl');
    window.open(pdfURL, '_blank');
  }catch (error){
       toast.error('Error al imprimir el servicio', {
              position: 'top-right',
              autoClose: 3000,
            });
  }
  };

  const handlePendiente = (service) => {
  if (window.confirm("¿Seguro de que quieres dejar el servicio pendiente?")) {
    const nuevaObservacion = `${service.noColaborador}-${service.sillaRuedas}`;
    axios.put(
      `${API_BASE_URL}api/servicios/${service._id}`,
      {
        statusServicio: 'PENDIENTE',
        noColaborador: 0,
        observaciones: nuevaObservacion,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    .then(() => {
      toast.success('Servicio marcado como pendiente.', {
        position: 'top-right',
        autoClose: 3000,
      });
      refreshServices(selectedOperator);
    })
    .catch((error) => {
      toast.error('Error al marcar como pendiente.', {
        position: 'top-right',
        autoClose: 3000,
      });
    });
  }
};

const iniciarServicio = async (_id) => {
  await actualizarStatus(_id, 'INICIADO');
};

const actualizarStatus = async (_id, nuevoStatus, camposExtra = {}) => {
  try {
    await axios.put(`${API_BASE_URL}api/servicios/${_id}`, {
      statusServicio: nuevoStatus,
      ...camposExtra, // esto permite incluir horaFin o lo que necesites
    }, {
      headers: { Authorization: `Bearer ${token}` },
    });

    toast.success(`Estado actualizado a ${nuevoStatus}`);
    refreshServices(selectedOperator);
  } catch (error) {
    console.error('Error al actualizar estado:', error);
    toast.error('No se pudo actualizar el estado.');
  }
};




const actualizarCheckpoint = async (_id, operador) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}api/servicios/${_id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const servicioActual = response.data;

    const tipo = servicioActual.tipoService?.toUpperCase();
    let checkpointActual = servicioActual.checkpoint;

    // Limpieza segura del valor actual
    if (typeof checkpointActual !== 'string') checkpointActual = '';
    checkpointActual = checkpointActual.trim().toUpperCase();

    console.log('📌 Tipo de vuelo:', tipo);
    console.log('📌 Checkpoint actual:', checkpointActual);

    let nuevoCheckpoint = '';

    if (tipo === 'MOSTRADOR') {
      if (!checkpointActual) {
        nuevoCheckpoint = 'CORRAL';
      } else if (checkpointActual === 'CORRAL') {
        nuevoCheckpoint = 'ABORDAJE';
      } else {
        nuevoCheckpoint = checkpointActual;
      }
    } else if (tipo === 'LLEGADAS') {
      if (!checkpointActual) {
        nuevoCheckpoint = 'DESEMBARQUE';
      } else if (checkpointActual === 'DESEMBARQUE') {
        nuevoCheckpoint = 'CORRAL';
      } else {
        nuevoCheckpoint = checkpointActual;
      }
    }

    console.log('✅ Nuevo checkpoint:', nuevoCheckpoint);

    // Si no hay cambios, salimos
    if (nuevoCheckpoint === checkpointActual) {
      toast.info('El checkpoint ya está actualizado.');
      return;
    }

    // Construir payload con actualizaciones
    const payload = {
      checkpoint: nuevoCheckpoint,
    };

    // Si es "CORRAL", actualizamos también status y noColaborador
    if (nuevoCheckpoint === 'CORRAL') {
      payload.statusServicio = 'CORRAL';
      payload.noColaborador = 0;
    }

    // Enviar actualización
    await axios.put(
      `${API_BASE_URL}api/servicios/${_id}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );

    toast.success(`Checkpoint actualizado a ${nuevoCheckpoint}`, {
      position: 'top-right',
      autoClose: 3000,
    });

    if (operador) refreshServices(operador);
  } catch (error) {
    console.error('❌ Error al actualizar checkpoint:', error);
    toast.error('Error al actualizar el checkpoint.');
  }
};

const validarQRContraServicio = async () => {
  if (!modalQR?.servicio?._id) {
  toast.error('No hay servicio seleccionado para validar.');
  return;
}

  try {
    const qrText = codigoQR.trim();
    const lineaSinPrefijo = qrText.substring(2);
    const primerEspacio = lineaSinPrefijo.indexOf(' ');
    const pnr = qrText.substring(23, 29);
    const noVuelo = qrText.substring(39, 43);
    const aerolinea = qrText.substring(36, 38);
    const noAsiento = qrText.substring(49, 52);
    const origenVuelo = qrText.substring(30, 33);
    const destinoVuelo = qrText.substring(33, 36);

    const response = await axios.get(`${API_BASE_URL}api/servicios/${modalQR.servicio._id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    const servicio = response.data;

    // Comparaciones
    const errores = [];
    if (servicio.qr?.trim().toUpperCase() !== pnr.toUpperCase()) errores.push('PNR');
    if (servicio.noAsiento?.trim().toUpperCase() !== noAsiento.toUpperCase()) errores.push('Asiento');
    if (servicio.origenVuelo?.trim().toUpperCase() !== origenVuelo.toUpperCase()) errores.push('Origen');
    if (servicio.destinoVuelo?.trim().toUpperCase() !== destinoVuelo.toUpperCase()) errores.push('Destino');
    if (servicio.aerolinea?.trim().toUpperCase() !== aerolinea.toUpperCase()) errores.push('Aerolínea');

    if (errores.length === 0) {
      toast.success('✅ QR validado correctamente');
      setQrValidado(true);
      setErroresQR([]);
    } else {
      toast.error('❌ QR inválido');
      setQrValidado(false);
      setErroresQR(errores);
    }
  } catch (error) {
    console.error('Error validando QR:', error);
    toast.error('Error al validar QR');
    setQrValidado(false);
    setErroresQR([]);
  }
};



const obtenerEstadosPorServicio = (tipoService, intNac) => {
  const tipo = tipoService?.toUpperCase();
  const nacionalidad = intNac?.toUpperCase();

  if (ESTADOS_SERVICIO[tipo] && ESTADOS_SERVICIO[tipo][nacionalidad]) {
    return ESTADOS_SERVICIO[tipo][nacionalidad];
  }

  return []; // Por si no coincide, devuelve vacío
};

const ejecutarAccionPorEtapa = (etapa, service) => {
  const statusActual = (service.statusServicio || '').toUpperCase();

  if (statusActual === 'ASIGNADO' && !['INICIADO', 'NOSHOW'].includes(etapa)) {
    toast.warning(
      'No puedes pasar de ASIGNADO a este estado. Primero inicia el servicio (escanea el pase) o marca No Show.'
    );
    return;
  }

  switch (etapa) {
    case 'INICIADO':
      setModalQR({ abierto: true, servicio: service });
      break;
    case 'STDBY':
      abrirModalCorral(service);
      break;
    case 'MIGRACION':
    case 'EQUIPAJE':
    case 'ADUANA':
    case 'ABORDAJE':
    case 'FINALIZADO':
    case 'NOSHOW':
      actualizarStatus(service._id, etapa);
      break;
    case 'CONCLUIDO':
      setMostrarModalEncuesta({ abierto: true, servicio: service }); // 🟢 Abrir modal de encuesta
      break;
    default:
      toast.info('Etapa no reconocida.');
  }
};




  

  return (
    <div className="daily-operators-container">
      <ToastContainer />
      <h3 style={{ marginTop: 10 }}>
  Estación actual: {estacionUsuario || 'No detectada'}
</h3>


      <h1>Operadores en Bitácora</h1>
      {/* Campo de búsqueda */}
      <div className="search-bar">
        <input
          type="text"
          value={searchSiglas}
          onChange={handleSearchSiglas}
          placeholder="Buscar por siglas..."
          className="search-input"
        />
      </div>
      <div className="operators-grid">
        {filteredOperators.map((operator, index) => (
          <div className="operator-card" key={index} onClick={() => handleCardClick(operator)}>
          <div className="operator-row top">
            <span>{operator.siglas}</span>
            <span>{operator.nombreCompleto}</span>
            <span>{operator.noColaborador}</span>
          </div>
          <div className="operator-row bottom">
            <span>Servicios en curso: {operator.serviciosEnCurso}</span>
          </div>
          <div className="operator-row bottom">
            <span>Servicios concluidos: {operator.serviciosConcluidos}</span>
          </div>
        </div>
        ))}
      </div>

      {showModal && (
  <div className="modal-overlay" onClick={closeModal}>
    <div className="modal" onClick={(e) => e.stopPropagation()}>
      <div className="modal-header">
        <h2>Servicios de {selectedOperator?.nombreCompleto}</h2>
      </div>
      <div className="modal-body">
        <div className="modal-services-grid">
        {selectedServices.map((service) => (
  <div key={service._id} className="modal-card">
  {/* Encabezado clickeable para expandir/colapsar */}
  <div
  className={`card-header-line clickable ${
    service.tipoSilla === 'UH' ? 'header-uh' : ''
  }`}
  onClick={() =>
    setSelectedServices((prev) =>
      prev.map((s) =>
        s._id === service._id
          ? { ...s, expanded: !s.expanded }
          : s
      )
    )
  }
>

  

  <div className="encabezado-servicio">
  <span className="tipo-servicio">
    [{service.tipoService === 'LLEGADAS' ? 'L' : 'S'}] {service.aerolinea} {service.noVuelo}
  </span>

  <span className="ruta-vuelo">
    {service.origenVuelo?.toUpperCase() || '???'} <span className="flecha">→</span> {service.destinoVuelo?.toUpperCase() || '???'}
  </span>

  <span className="no-servicio">#{service._id}</span>
</div>


</div>


  {/* Línea de progreso */}
{(() => {
  const etapas = obtenerEstadosPorServicio(service.tipoService, service.int_nac);
  const currentIndex = etapas.indexOf(service.statusServicio?.toUpperCase());

  const getIcon = (etapa,idx) => {
    switch (etapa) {
      case 'ASIGNADO': return <i className='fa fa-user' />
      case 'INICIADO': return <i className="fa fa-play" />;
      case 'STDBY': return <i className="fa fa-pause-circle" />;
      case 'MIGRACION': return <i className="fa fa-passport" />;
      case 'EQUIPAJE': return <i className="fa fa-suitcase" />;
      case 'ADUANA': return <i className="fa fa-search-dollar" />;
      case 'CONCLUIDO': return <i className="fa fa-check-circle" />;
      case 'NOSHOW': return <i className="fa fa-user-slash" />;
      case 'ABORDAJE': return <i className="fa fa-plane-departure" />;
      case 'FINALIZADO': return <i className="fa fa-check" />;
      default: return idx + 1;
    }
  };

  return (
    <div className="status-progress-bar icon-only">
      {etapas.map((etapa, idx) => {
        const isActive = idx <= currentIndex;
        return (
          <React.Fragment key={etapa}>
            <button
  className={`circle-step ${isActive ? 'active' : ''}`}
  title={etapa}
  onClick={() => ejecutarAccionPorEtapa(etapa, service)}
>
  {getIcon(etapa)}
</button>

            {idx < etapas.length - 1 && <div className={`step-line ${isActive ? 'active' : ''}`} />}
          </React.Fragment>
        );
      })}
    </div>
  );
})()}





  {/* Detalles expandidos */}
  {service.expanded && (
    <>
      <div className="info-pax-vuelo">
        <div className="info-pax">PAX: {service.nombrePax}</div>
        <div className="info-vuelo">{service.aerolinea} {service.noVuelo}</div>
      </div>

<p><strong>Hora Inicio:</strong> {moment(service.horaInicio).format('HH:mm')}</p>
<p>
  <strong>Hora Fin:</strong>{' '}
  {service.horaFin ? moment(service.horaFin).format('HH:mm') : 'Sin finalizar'}
</p>

      
    </>
  )}
</div>


))}

        </div>
      </div>
      <div className="modal-footer">
        <button className="close-button" onClick={closeModal}>
          Cerrar
        </button>
      </div>
    </div>
  </div>
)}

{modalQR.abierto && (
  <div className="modal-overlay">
    <div className="modal" style={{ maxWidth: 500 }}>
      <h3>Escanear pase de abordar</h3>
      <label>Código QR:</label>
      <div style={{ display: 'flex', gap: 10 }}>
        <input
          type="text"
          value={codigoQR}
          onChange={(e) => setCodigoQR(e.target.value)}
          placeholder="Escanea o ingresa el código"
          className="search-input"
        />
        <button
  className="btn-transfer"
  onClick={validarQRContraServicio}
>
  Validar
</button>

{erroresQR.length > 0 && (
  <div style={{ marginTop: 10, color: 'red' }}>
    <strong>❌ Campos no coinciden:</strong>
    <ul>
      {erroresQR.map((campo, index) => (
        <li key={index}>• {campo}</li>
      ))}
    </ul>
  </div>
)}

{qrValidado && (
  <div style={{ marginTop: 10, color: 'green' }}>
    <strong>✅ QR válido. Puedes iniciar el servicio.</strong>
  </div>
)}


      </div>

      <button
        className="btn-concluir"
        style={{ marginTop: 20 }}
        disabled={!qrValidado}
        onClick={async () => {
          try {
            await actualizarStatus(modalQR.servicio._id, 'INICIADO');
            toast.success('Servicio iniciado');
            setModalQR({ abierto: false, servicio: null });
            setQrValidado(false);
            setCodigoQR('');
          } catch (error) {
            toast.error('Error al iniciar servicio');
          }
        }}
      >
        Iniciar Servicio
      </button>

      <button
        className="btn-cancel"
        onClick={() => {
          setModalQR({ abierto: false, servicio: null });
          setQrValidado(false);
          setCodigoQR('');
        }}
      >
        Cancelar
      </button>
    </div>
  </div>
)}



     

      {isModalTransferOpen && (
        <div className="modal-overlay">
          <div className="modal">
            <h2>Transferir Servicio</h2>
            <div className="modal-content">
              <label htmlFor="siglas">Siglas del operador:</label>
              <input
                type="text"
                id="siglas"
                value={siglas}
                readOnly
                placeholder="Seleccione las siglas del operador"
              />
              <button
                className="btn-select"
                onClick={() => {
                  setIsModalSeleccionOpen(true);
                  abrirModalSeleccionOperador();
                }}
              >
                Seleccionar
              </button>
              {noColaboradorDestino && (
                <div className="operator-info">
                  <p>
                    <strong>Número de colaborador:</strong> {noColaboradorDestino}
                  </p>
                </div>
              )}
              <button
                className="btn-transfer"
                onClick={transferirServicio}
                disabled={!noColaboradorDestino || loadingTransfer}
              >
                {loadingTransfer ? 'Transfiriendo...' : 'Confirmar Transferencia'}
              </button>
            </div>
            <button className="btn-cancel" onClick={() => setIsModalTransferOpen(false)}>
              Cancelar
            </button>
          </div>
        </div>
      )}

      {isModalSeleccionOpen && (
        <div className="modal-overlay">
          <div className="modal">
            <h2>Seleccionar Operador</h2>
            <div className="modal-content">
              {loadingTransfer ? (
                <p>Cargando operadores...</p>
              ) : (
                operadoresDisponibles.map((operador) => (
                  <div
                    key={operador.noColaborador}
                    className="operador-item"
                    onClick={() => {
                      setSiglas(operador.siglas);
                      setNoColaboradorDestino(operador.noColaborador);
                      setIsModalSeleccionOpen(false);
                      toast.success(`Operador seleccionado: ${operador.nombreCompleto}`, {
                        position: 'top-right',
                        autoClose: 3000,
                      });
                    }}
                  >
                    <p>
                      <strong>Siglas:</strong> {operador.siglas}
                    </p>
                    <p>
                      <strong>Nombre:</strong> {operador.nombreCompleto}
                    </p>
                  </div>
                ))
              )}
            </div>
            <button className="btn-cancel" onClick={() => setIsModalSeleccionOpen(false)}>
              Cancelar
            </button>
          </div>
        </div>
      )}

      {isConcluirModalOpen && selectedService && (
        <ModalConcluirServicio
          servicio={selectedService}
          onClose={() => {
            setIsConcluirModalOpen(false);
            window.location.reload();
          }}
          onUpdate={() => toast.success('Servicio actualizado correctamente.')}
        />
      )}

      {modalCorral.abierto && (
  <div className="modal-overlay">
    <div className="modal">
      <h3>Selecciona ubicación CORRAL</h3>
      {['STDBY POS-66', 'STADBY POS-54', 'STDBY POS-DL'].map((corral) => (
  <button
    key={corral}
    className="btn-transfer"
    onClick={async () => {
      try {
        await axios.put(`${API_BASE_URL}api/servicios/${modalCorral.servicio._id}`, {
          statusServicio: 'CORRAL',
          checkpoint: corral,
          noColaborador: 0,
        }, {
          headers: { Authorization: `Bearer ${token}` },
        });

        toast.success(`Servicio enviado a ${corral}`, {
          position: 'top-right',
          autoClose: 3000,
        });

        setModalCorral({ abierto: false, servicio: null });
        refreshServices(selectedOperator);
      } catch (error) {
        console.error('Error al enviar a corral:', error);
        toast.error('No se pudo actualizar el corral.', {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    }}
  >
    {corral}
  </button>
))}

      <button className="btn-cancel" onClick={() => setModalCorral({ abierto: false, servicio: null })}>
        Cancelar
      </button>
    </div>
  </div>
)}


      {mostrarModalEncuesta && (
  <div className="modal-encuesta-overlay">
    <div className="modal-encuesta">
<h3 style={{ textAlign: 'center', lineHeight: 1.4 }}>
  Califica el servicio de nuestro Agente<br />
  <strong>{selectedOperator?.nombreCompleto}</strong>
</h3>

      <div className="caritas-feedback">
  <button onClick={() => setFeedback('EXCELENTE')} className={feedback === 'EXCELENTE' ? 'selected' : ''}>
    😊<br /><strong>BUENO</strong>
  </button>
  <button onClick={() => setFeedback('INTERMEDIO')} className={feedback === 'INTERMEDIO' ? 'selected' : ''}>
    😐<br /><strong>MEDIO</strong>
  </button>
  <button onClick={() => setFeedback('MALO')} className={feedback === 'MALO' ? 'selected' : ''}>
    😡<br /><strong>MALO</strong>
  </button>
</div>


      <textarea
        placeholder="Comentarios (opcional)"
        value={comentarios}
        onChange={(e) => setComentarios(e.target.value)}
        rows={3}
        className="comentarios-textarea"
      />

      {/* Firma de pasajero y agente en la misma fila */}
      <div className="firmas-row">
        {/* Firma del pasajero */}
        <div className="firma-box">
          <div className="firma-label">Firma del pasajero:</div>
          <div className="firma-wrapper">
            <SignatureCanvas
              ref={firmaPasajeroRef}
              penColor="black"
              canvasProps={{ width: 300, height: 150, className: 'firma-canvas' }}
            />
            <div className="firma-marca-agua">PASAJERO</div>
          </div>
          <button className="btn-borrar-firma" onClick={() => firmaPasajeroRef.current.clear()}>
            Borrar firma
          </button>
        </div>

        {/* Firma del agente 
        <div className="firma-box">
          <div className="firma-label">Firma del agente:</div>
          <div className="firma-wrapper">
            <SignatureCanvas
              ref={firmaAgenteRef}
              penColor="black"
              canvasProps={{ width: 300, height: 150, className: 'firma-canvas' }}
            />
            <div className="firma-marca-agua">AGENTE AEROLÍNEA</div>
          </div>
          <button className="btn-borrar-firma" onClick={() => firmaAgenteRef.current.clear()}>
            Borrar firma
          </button>
        </div> */}
      </div>

      <div className="modal-buttons">
        <button className="btn-cancelar" onClick={() => setMostrarModalEncuesta(false)}>Cancelar</button>
        <button
  className="btn-concluir"
  onClick={async () => {
    const firmaPasajeroVacia = firmaPasajeroRef.current?.isEmpty?.();

    if (!feedback) {
      toast.error('Por favor selecciona una calificación.');
      return;
    }

    if (firmaPasajeroVacia) {
      toast.error('La firma del pasajero es obligatoria.');
      return;
    }

    // Firma y hora
    const horaFin = moment().format('YYYY-MM-DD HH:mm:ss');

    // Llamada a la función modificada
    await actualizarStatus(
      mostrarModalEncuesta.servicio._id,
      'CONCLUIDO',
      { horaFin } // ⬅️ Campos extra
    );

    setMostrarModalEncuesta(false);
  }}
>
  Concluir
</button>

      </div>
    </div>
  </div>
)}


    </div>
  );
};

export default DailyOperatorsInfo;
